import React from 'react';
import { Divider } from '@fiverr-private/layout_components';
import { FiltersModal } from '../../../FiltersModal/FiltersModal';
import FloatingMenu from '../../../menus/FloatingMenu';
import { OnlineNowToggle } from '../../../menus/content/toggleFilters/online_now_toggle';
import ProToggle from '../../../menus/content/toggleFilters/pro_toggle';
import { SimilarTimezoneToggle } from '../../../menus/content/toggleFilters/similar_timezone_toggle';
import { CategoryOptionPill } from '../CategoryOptionPill';
import { PriorityFilterOption } from '../PriorityFilterOption';
import { SelectedFilterChip } from '../SelectedFilterChip';
import type { FilterRowItemData } from '../../FilterRow.types';

export const FilterRowItem = (item: FilterRowItemData) => {
    switch (item.type) {
        case 'filterTrigger':
            return <FiltersModal {...item.props} />;
        case 'dropdown':
            return <FloatingMenu {...item.props} />;
        case 'divider':
            return <Divider direction="vertical" height="32px" />;
        case 'priorityOption':
            return <PriorityFilterOption {...item.props} />;
        case 'categoryOption':
            return <CategoryOptionPill {...item.props} />;
        case 'chip':
            return <SelectedFilterChip {...item.props} />;
        case 'onlineNowToggle':
            return <OnlineNowToggle {...item.props} />;
        case 'proToggle':
            return <ProToggle {...item.props} />;
        case 'similarTimezoneToggle':
            return <SimilarTimezoneToggle {...item.props} />;
        default:
            return null;
    }
};
